/**
 * Valid color values accepted by TableOutput.Status from @general-backoffice/core.
 */
type StatusColorValue =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "light"
  | "dark"
  | "white";

const VALID_COLORS: Record<StatusColorValue, true> = {
  default: true,
  primary: true,
  secondary: true,
  success: true,
  danger: true,
  warning: true,
  info: true,
  light: true,
  dark: true,
  white: true,
};

/**
 * Safely retrieve a status color from a color map.
 * Returns a properly typed Color value, or undefined if the color is not
 * a recognized Color literal.
 */
export function getStatusColor(
  colorMap: Record<string, string>,
  status: string | null | undefined,
  fallbackStatus = "pending"
): StatusColorValue | undefined {
  const color = colorMap[status || fallbackStatus];
  if (color && color in VALID_COLORS) {
    // color is validated against VALID_COLORS keys which are StatusColorValue

    return color as StatusColorValue;
  }
  return undefined;
}
